import {Component, OnInit, TemplateRef} from '@angular/core';
import {ApplicationService} from '../../../services/application.service';
import {Application} from '../../../domain/onBoarding/application';
import {ActivatedRoute, Router} from '@angular/router';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {CommonComponent} from '../../shared/common/common.component';
import {NotificationsService} from '../../../services/notifications.service';
import {ToastaService} from 'ngx-toasta';
import {LangChangeEvent, TranslateService} from '@ngx-translate/core';
import {NgForm} from '@angular/forms';
import {ExternalService} from '../../../services/external.service';
import {WebcamInitError} from 'ngx-webcam';
import {Observable, Subject} from 'rxjs';
import {DialogService} from 'primeng/dynamicdialog';
import {ConfigurationService} from '../../../services/configuration.service';
import {CountryCode} from '../../../entity/CountryCodeEntity';
import {ReCaptchaV3Service} from 'ng-recaptcha';

@Component({
  selector: 'app-contact-data',
  templateUrl: './contact-data.component.html',
  styleUrls: ['./contact-data.component.scss']
})
export class ContactDataComponent extends CommonComponent implements OnInit {
  application: Application;
  private trigger: Subject<void> = new Subject<void>();
  public errors: WebcamInitError[] = []; // DELETE?
  public allowCameraSwitch = false; // DELETE?
  public cameraPerms = true; // DELETE
  registeredCellphone: string;
  registeredCountryCode: string;

  otpLength = 6;
  phoneOtpSent = false;

  passwordMinLength: boolean;
  passwordCapsLower: boolean;
  passwordNumber: boolean;
  passwordSpecial: boolean;
  passwordSpaces: boolean;
  passwordSequences: boolean;
  passwordRepetition: boolean;
  showPassword = true;
  showMatchingPassword = true;
  validatingOtp: boolean;
  displayPrivacyModal = false;
  displayButtonBack = true;
  displayConfirm =  false;
  countryCodes: CountryCode[] = [];
  re = '';

  isDropdownOpen = false;
  selectedCountryCode: { dialCode: string; name: string } | null = null;

  constructor(
    protected router: Router,
    private activatedRoute: ActivatedRoute,
    private applicationService: ApplicationService,
    private externalService: ExternalService,
    protected modalService: NgbModal,
    protected notificationsService: NotificationsService,
    protected toastService: ToastaService,
    public translate: TranslateService,
    protected dialogService: DialogService,
    public configurationService: ConfigurationService,
    private recaptchaV3Service: ReCaptchaV3Service
  ) {
    super(modalService, notificationsService, toastService, router, translate, dialogService);
    this.application = applicationService.application;

    translate.onLangChange.subscribe(
      (event: LangChangeEvent) => {
        this.countryCodes = this.countryCodeCatalog(this.configurationService.application);
      });
  }

  ngOnInit(): void {

    scroll(0, 0);
    this.countryCodes = this.countryCodeCatalog(this.configurationService.application);

    if (!this.application || !this.application.editing) {
      this.router.navigate(['/onboarding/']);
      return;
    }
    this.application.body.phoneCountryCode = !this.application.body?.phoneCountryCode ? '1' : this.application.body?.phoneCountryCode;
    if (this.application.body.password) {
      this.passwordValidation();
    }
    if (this.application.body.applicationRejected && this.application.editing) {
      this.router.navigate(['/onboarding/usaIds']);
    }
    if (this.configurationService.application.brokerEnabled === false) {
      this.displayPrivacyModal = true;
      this.displayButtonBack = false;
    }
    if (this.application.body.cellphone) {
      this.registeredCellphone = this.application.body.cellphone;
      this.registeredCountryCode = this.application.body.phoneCountryCode;
    }
  }

  handleBlur(param: string) {
    setTimeout(() => {
      param === 'first' ? this.showPassword = false : this.showMatchingPassword = false
    }, 100);
  }

  onSubmit() {
    this.application.editing = true;
    if (this.application.body.ipAddress != null && this.application.body.ipAddress !== '') {
      this.application.confirmedPhoneNumber = true;
      this.router.navigate(['/onboarding/usaIds']);
    } else {
      this.msgWarning(this.translate.instant('onboarding.contact-data.ip-error', {Default: 'No pudimos obtener tu dirección IP por favor actualiza el portal para volverlo a intentar.'}));
    }
  }

  generateRecaptcha(){
    this.recaptchaV3Service.execute('send_otp').subscribe((token) => {
      this.sendOtp(token);
    }, error => {
      this.msgError(error, this.translate.instant('shared.common.general_error_message'));
    }
    );
  }
  sendOtp(token: string) {
    this.loadingModalOn();
    let data;
    data = {
      phoneCountryCode: this.application.body.phoneCountryCode,
      cellphone: this.application.body.cellphone,
      reCaptchaToken: token
    };
    this.applicationService.sendOtp(data, 'phone').subscribe(
      (response: any) => {
        this.msgSuccess(this.translate.instant('onboarding.contact-data.sentOTPMessage', {re: this.re}));
        this.phoneOtpSent = true;
        this.re = '';
        this.loadingModalOff();
      },
      error => {
        this.loadingModalOff();
        this.msgError(error);
      }
    );
  }

  validateCellPhone(otp) {
    if (!this.application.confirmedPhoneNumber && otp.length === this.otpLength && !this.validatingOtp) {
      this.loadingModalOn();
      this.validatingOtp = true;
      this.application.body.phoneOtp = otp;
      this.applicationService.setApplication().subscribe(
        (response: any) => {
          if (!this.application.body.applicationId) {
            this.application.body.applicationId = response.applicationId;
          }
          this.msgSuccess(this.translate.instant('onboarding.contact-data.verifiedOTPMessage', {Default: 'Código verificado'}));
          this.application.confirmedPhoneNumber = true;
          this.phoneOtpSent = false;
          this.loadingModalOff();
          this.validatingOtp = false;
          this.registeredCellphone = this.application.body.cellphone;
          this.registeredCountryCode = this.application.body.phoneCountryCode;
        },
        error => {
          this.loadingModalOff();
          this.validatingOtp = false;
          switch (error.status) {
            case 403:
            case 422:
              this.msgError(error, this.translate.instant('onboarding.contact-data.invalidOTPMessage', {Default: 'Código inválido'}));
              break;
            default:
              this.msgError(this.translate.instant('onboarding.contact-data.generalError', {Default: 'Ocurrió un error con tu solicitud'}));
              break;
          }
        }
      );
    }
  }

  passwordValidation() {
    this.passwordMinLength = this.application.body.password?.length >= 8 && this.application.body.password?.length <= 128;
    this.passwordCapsLower = this.passwordCapsValidation(this.application.body.password)
      && this.passwordLowerCaseValidation(this.application.body.password);
    this.passwordNumber = this.passwordNumberValidation(this.application.body.password);
    this.passwordSpecial = this.passwordSpecialValidation(this.application.body.password);
    this.passwordSequences = !this.passwordSequencesValidation(this.application.body.password);
    this.passwordRepetition = this.passwordRepetitionValidation(this.application.body.password);
    this.passwordSpaces = this.passwordSpacesValidation(this.application.body.password);
  }

  phoneNumberChange(form: NgForm) {
    this.application.confirmedPhoneNumber = false;
    this.phoneOtpSent = false;
    this.toastService.clearAll();
  }

  openModal(content: TemplateRef<any>): void {
    this.modalService.open(content, {
      size: 'md',
      centered: true,
      backdrop: 'static',
      keyboard: false
    });
  }
  public handleInitError(error: WebcamInitError): void {
    this.loadingModalOn();
    this.errors.push(error);
    this.msgError(error, this.translate.instant('onboarding.contact-data.cameraUsageDenied', {Default: 'Es necesario que permita el uso de su cámara web. Por favor, brinde autorización y recargue la página.'}));
    this.router.navigate(['/']);
    this.application = null;
    this.cameraPerms = false;
    this.loadingModalOff();
  }

  public get triggerObservable(): Observable<void> {
    return this.trigger.asObservable();
  }
  onBack() {
    if (this.registeredCellphone) {
      this.application.body.cellphone = this.registeredCellphone;
      this.application.body.phoneCountryCode = this.registeredCountryCode;
      this.application.confirmedPhoneNumber = true;
    }
    this.router.navigate(['/onboarding/addReferrer']);
  }

  toggleDropdown(): void {
    this.isDropdownOpen = !this.isDropdownOpen;
  }

  selectCountry(country: { dialCode: string; name: string }): void {
    this.application.body.phoneCountryCode = country.dialCode;
    this.selectedCountryCode = country;
    this.isDropdownOpen = false;
  }

}
